import type { ReviewStatus } from "../../Project/types/project-attachment-workflow.types.ts"

/** Shared by `ReviewDrawer` and the cross-project Document Review page so the
 * two surfaces can't drift on what color a review status renders as. */
const REVIEW_STATUS_COLOR: Record<ReviewStatus, string> = {
  pending: "processing",
  approved: "success",
  rejected: "error",
  changes_requested: "warning"
}

export { REVIEW_STATUS_COLOR }
